export const PLAN_RANK = { starter: 0, growth: 1, scale: 2, fund_manager: 3 };

export const PLAN_META = {
  growth: {
    key: "growth",
    name: "Growth",
    monthly: 49,
    yearly: 490,
    tagline: "For growing startups who report to a widening investor base.",
    benefits: [
      "Up to 150 investors",
      "Unlimited AI-drafted updates",
      "Fundraising CRM + round modeling",
      "Tracked deck links",
      "Cap table + 10 employee equity pages",
      "3 team seats",
    ],
  },
  scale: {
    key: "scale",
    name: "Scale",
    monthly: 99,
    yearly: 990,
    tagline: "For scaling companies that need documents, e-signatures and depth.",
    benefits: [
      "Everything in Growth",
      "Up to 500 investors",
      "Data rooms with view tracking",
      "Document Builder + e-signatures",
      "100 employee equity pages",
      "10 team seats",
      "Priority support",
    ],
  },
  fund_manager: {
    key: "fund_manager",
    name: "Fund Manager",
    monthly: 249,
    yearly: 2490,
    tagline: "For GPs running funds and SPVs with LP reporting at scale.",
    benefits: [
      "Everything in Scale",
      "Unlimited funds & SPVs",
      "LP portal, capital calls & waterfalls",
      "Quarterly LP report PDFs",
      "Up to 1,000 investors & LPs",
      "25 team seats",
    ],
  },
};

export const planRank = (plan) => PLAN_RANK[plan] ?? 0;

export const needsUpgrade = (currentPlan, minPlan) =>
  Boolean(minPlan) && planRank(minPlan) > planRank(currentPlan || "starter");

export const requiredPlanFromMessage = (message, currentPlan) => {
  const m = (message || "").toLowerCase();
  if (m.includes("fund manager plan")) return "fund_manager";
  if (m.includes("scale plan")) return "scale";
  if (m.includes("growth plan")) return "growth";
  return (currentPlan || "starter") === "growth" ? "scale" : "growth";
};

export const openUpgrade = (detail = {}) =>
  window.dispatchEvent(new CustomEvent("tenx:upgrade-required", { detail }));
